import { Headset, Rocket, TrendingUp, Search } from "lucide-react";

const services = [
  {
    icon: Headset,
    title: "Support & Advisory",
    description:
      "We provide practical, reliable support and strategic advice to keep your ServiceNow platform running smoothly and aligned with your goals. From day-to-day troubleshooting to long-term planning, we help you make smart decisions that improve performance, security, and scalability.",
    id: "support-advisory",
  },
  {
    icon: Rocket,
    title: "Projects & Implementations",
    description:
      "We plan, deliver, and implement ServiceNow projects that work — on time and with minimal disruption. From additional modules to new platform rollouts, we manage the details end to end to ensure smooth implementation, user adoption, and measurable results.",
    id: "projects-implementations",
  },
  {
    icon: TrendingUp,
    title: "System Enhancements",
    description:
      "We help you do the little things that optimise and enhance your existing platform. The things that you should do to leverage your investment, but may not have the capacity or capability, helping you to achieve more without unnecessary complexity and cost.",
    id: "system-enhancements",
  },
  {
    icon: Search,
    title: "Process Consulting",
    description:
      "We analyse and refine your business processes to improve efficiency, consistency, and outcomes. By identifying gaps and streamlining workflows, we help you reduce friction, improve performance, and be ready for new systems or automation.",
    id: "process-consulting",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0047AB] mb-3">
            What We Do
          </p>
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-900">
            Our Services
          </h2>
        </div>

        {/* Services Grid - Technical Look with borders */}
        <div className="grid md:grid-cols-2 border border-slate-200 rounded-xl overflow-hidden">
          {services.map((service, idx) => {
            const Icon = service.icon;
            return (
              <div
                key={service.id}
                data-testid={`service-card-${service.id}`}
                className={`group p-8 lg:p-10 transition-all duration-300 hover:bg-slate-50 ${
                  idx < 2 ? "border-b border-slate-200" : ""
                } ${idx % 2 === 0 ? "md:border-r border-slate-200" : ""}`}
              >
                <div className="flex items-center gap-4 mb-5">
                  <div className="w-12 h-12 rounded-lg bg-[#DBEAFE] flex items-center justify-center group-hover:bg-[#0047AB] transition-colors duration-300">
                    <Icon
                      size={22}
                      className="text-[#0047AB] group-hover:text-white transition-colors duration-300"
                    />
                  </div>
                  <h3 className="text-xl font-medium tracking-tight text-slate-900">
                    {service.title}
                  </h3>
                </div>
                <p className="text-sm text-slate-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
